// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss, modalButtonsActionStyles } from "@awc/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import { css } from "styled-components";

addToListModalStyles.newListInput = {
    cssOverrides: {
        formField: css`
            margin-top: 15px;
        `,
    },
    placeholder: translate("New List Name"),
};

addToListModalStyles.buttonsWrapper = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            margin-top: 20px;
        `,
    }),
};

addToListModalStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

addToListModalStyles.addButton = {
    ...modalButtonsActionStyles.submitButton,
};

addToListModalStyles.modal = {
    sizeVariant: "small",
};
